import { BasicNonprofit, Nonprofit } from '@core/models/npo.model';
import { CACHE_TYPES, CachedAttr } from '@yourcause/common/cache';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

/**
 * State interface for managing active nonprofit data.
 */
export interface INonprofitState {
  /**
   * User Id of the current user when the active nonprofit is set.
   * (when switching users we need to clear the active nonprofit)
   */
  userId: number;
  /**
   * The ID of the current active nonprofit
   * Stored in localstorage for reloading when the user navigates away and returns
  */
  activeNpoId: number | null;

  /** The object of the current active nonprofit */
  activeNpo: Nonprofit | null;

  /** The logo URL for the current active nonprofit */
  nonprofitLogo: string | null;

  /** The active nonprofit state data with any temporary modifications */
  activeNpoStateData: Nonprofit | null;
}

@RegisterYCState()
export class NonprofitState extends BaseYcState implements INonprofitState {
  @CachedAttr(CACHE_TYPES.LOCALSTORAGE)
  readonly userId: number;
  @CachedAttr(CACHE_TYPES.LOCALSTORAGE)
  readonly activeNpoId: number;
  readonly activeNpo: Nonprofit;
  readonly myNpos: BasicNonprofit[];
  readonly activeNpoStateData: Nonprofit;
  readonly nonprofitLogo: string;
}
